export {default} from './superuser.vue'